import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  makeStyles,
} from '@fluentui/react-components';
import { useContext } from 'react';
import { SignInContext, UserLabel } from '@modules/users';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { TLockedState } from '@modules/documents/types';

type TProps = {
  state?: TLockedState;
  setState: (lockedData?: TLockedState) => void;
};

const useStyles = makeStyles({
  primaryAction: {
    // DialogActions lets buttons shrink below their label width, and the Button root clips overflow.
    whiteSpace: 'nowrap',
  },
});

const LockedDialog = ({ state, setState }: TProps) => {
  const { user } = useContext(SignInContext);

  const classes = useStyles();
  return (
    <Dialog
      open={state?.isOpen || false}
      onOpenChange={(e, data) => {
        e.stopPropagation();
        if (state) setState({ ...state, isOpen: data.open });
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <DialogTrigger action="close">
                <Button appearance="subtle" aria-label="close" icon={<Dismiss24Regular />} />
              </DialogTrigger>
            }
          >
            {user._id === state?.lockedUserId ? (
              <>You are currently editing this document in another tab/browser.</>
            ) : (
              <>
                <UserLabel id={state?.lockedUserId} /> is currently editing this document.
              </>
            )}
          </DialogTitle>

          <DialogContent>
            {state?.message || 'A document can only be edited by one user at a time.'} Please inform the current editor
            to refresh the page or switch to view mode.
          </DialogContent>
          <DialogActions>
            {state?.primaryAction && (
              <Button
                appearance="primary"
                onClick={() => {
                  state.primaryAction?.onClick();
                }}
                className={classes.primaryAction}
              >
                {state.primaryAction.label}
              </Button>
            )}
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">Close</Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default LockedDialog;
